// extracted by mini-css-extract-plugin
export var alignBaseline = "_g-9";
export var alignCenter = "_g-5";
export var alignFlexEnd = "_g-7";
export var alignFlexStart = "_g-6";
export var alignSelfBaseline = "_g-e";
export var alignSelfCenter = "_g-a";
export var alignSelfFlexEnd = "_g-c";
export var alignSelfFlexStart = "_g-b";
export var alignSelfStretch = "_g-d";
export var alignStretch = "_g-8";
export var column = "_g-2";
export var columnReverse = "_g-4";
export var flex = "_g-0";
export var justifyCenter = "_g-f";
export var justifyFlexEnd = "_g-h";
export var justifyFlexStart = "_g-g";
export var justifySpaceAround = "_g-j";
export var justifySpaceBetween = "_g-i";
export var justifySpaceEvenly = "_g-k";
export var row = "_g-1";
export var rowReverse = "_g-3";
export var wrapNowrap = "_g-m";
export var wrapWrap = "_g-l";
export var wrapWrapReverse = "_g-n";